import { useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import RequestServies from "../../../services/RequestServies";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";

const TransferReport = () => {
    const [open, setOpen] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");
    const [open2, setOpen2] = useState(true);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState("all");
    const [totalcount, setTotalCount] = useState(0)
    const [page, setPage] = useState(1);
    const limit = 200;
    const [totalPages, setTotalPages] = useState(1);

    // ✅ Date range validation (max 31 days)
    const isDateRangeValid = (from, to) => {
        const start = new Date(from);
        const end = new Date(to);

        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        const diffTime = end - start;
        const diffDays = diffTime / (1000 * 60 * 60 * 24);

        return diffDays <= 30; // ✅ allows 31 days
    };

    const fetchReport = async () => {
        if (!fromDate || !toDate) {
            Swal.fire({
                icon: "warning",
                title: "Missing Dates",
                text: "Please select both From and To dates.",
            });
            return;
        }

        // ✅ NEW VALIDATION (ONLY FOR GENERATE)
        if (!isDateRangeValid(fromDate, toDate)) {
            Swal.fire({
                icon: "warning",
                title: "Invalid Range",
                text: "You can generate report for maximum 31 days only.",
            });
            return;
        }

        setPage(1);
        setLoading(true);
        try {
            const response = await RequestServies.reportTransferItems({
                fromDate,
                toDate,
                status,
                page: 1,
                limit
            });

            setReportData(response.data);
            setTotalCount(response.count);
            setTotalPages(response.totalPages);

            Swal.fire({
                icon: "success",
                title: "Report Generated",
                text: `Report Successfully Generated for the Selected Date Range.`,
            });

        } catch (error) {
            console.error("Error fetching report data:", error);

            Swal.fire({
                icon: "error",
                title: "Fetch Error",
                text: "Failed to fetch report data. Please try again later.",
            });

        } finally {
            setLoading(false);
        }
    };

    const filteredData = reportData.filter((item) => {
        // Convert the search string to lowercase and split by space or comma
        const queries = (searchQuery || "")
            .toLowerCase()
            .split(/[\s,]+/)
            .filter(q => q.trim() !== "");

        return queries.every(query =>
            String(item?.transfer?.storeFrom?.name || "").toLowerCase().includes(query) ||
            String(item?.transfer?.storeTo?.name || "").toLowerCase().includes(query) ||
            String(item?.transfer?.transferNo || "").toLowerCase().includes(query) ||
            String(item?.inventory?.masterItem?.partNo || "").toLowerCase().includes(query) ||
            String(item?.inventory?.masterItem?.description || "").toLowerCase().includes(query)
        );
    });


    const downloadExcel = async () => {
        if (!fromDate || !toDate) {
            Swal.fire({
                icon: "warning",
                title: "Missing Dates",
                text: "Please select both From and To dates.",
            });
            return;
        }

        try {
            Swal.fire({
                title: "Preparing Report...",
                text: "Downloading full data...",
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading()
            });

            const response = await RequestServies.downloadTransferReport({
                fromDate,
                toDate,
                status
            });

            // ✅ Create file from blob
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;

            // ✅ Dynamic file name
            const fileName = `Transfer_Report_${new Date().toISOString().split("T")[0]}.xlsx`;
            link.setAttribute("download", fileName);

            document.body.appendChild(link);
            link.click();
            link.remove();

            Swal.fire("Success", "Report Downloaded", "success");

        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Download failed", "error");
        }
    };

    return (
        <>
            <div className="col-xl-12">
                <div className="filter cm-content-box box-primary">
                    <div className={`content-title`}>
                        <div className="cpa">
                            <i className="fas fa-filter me-2"></i>Filter
                        </div>
                        <div className="tools">
                            <Link
                                to={"#"}
                                className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                                onClick={() => setOpen(!open)}
                            >
                                <i className="fas fa-angle-up"></i>
                            </Link>
                        </div>
                    </div>
                    <Collapse in={open}>
                        <div className="cm-content-body form excerpt">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-3 col-xxl-3">
                                        <label className="ms-2">From</label>
                                        <input
                                            type="date"
                                            name="fromDate"
                                            className="form-control mb-xxl-0 mb-3"
                                            value={fromDate}
                                            onChange={(e) => setFromDate(e.target.value)}
                                        />
                                    </div>

                                    <div className="col-xl-3 col-xxl-3">
                                        <label className="ms-2">To</label>
                                        <input
                                            type="date"
                                            name="toDate"
                                            className="form-control mb-xxl-0 mb-3"
                                            value={toDate}
                                            onChange={(e) => setToDate(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-xl-3 col-xxl-3">
                                        <label className="ms-2">Status</label>
                                        <select
                                            className="form-select"
                                            value={status}
                                            style={{ height: '55px' }}
                                            onChange={(e) => setStatus(e.target.value)}
                                        >

                                            <option value="all">All</option>
                                            <option value="pending">Approval Pending</option>
                                            <option value="recived">Completed</option>
                                            <option value='approved'>Pending Received Order</option>
                                            <option value='rejected'>Rejected by Admin</option>
                                        </select>
                                    </div>
                                    <div className="col-xl-3 col-xxl-3">
                                        <label className="ms-2">Action</label>

                                        <div className="d-flex gap-2">
                                            <button
                                                className="form-control btn btn-primary"
                                                onClick={fetchReport}
                                                disabled={loading}
                                            >
                                                {loading ? "Loading..." : "Generate"}
                                            </button>

                                            <button
                                                className="btn btn-success w-100"
                                                onClick={downloadExcel}
                                                disabled={!fromDate || !toDate}
                                            >
                                                Download
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Collapse>
                </div>

                <div className="filter cm-content-box box-primary">
                    <div className={`content-title`}>
                        <div className="cpa">
                            <i className="fa fa-list me-2" aria-hidden="true"></i>Transfer
                            Report<span className="badge bg-orange ms-2">{totalcount}</span>
                        </div>
                        <div className="tools">
                            <Link
                                to={"#"}
                                className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                                onClick={() => setOpen2(!open2)}
                            >
                                <i className="fas fa-angle-up"></i>
                            </Link>
                        </div>
                    </div>
                    <Collapse in={open2}>
                        <div className="cm-content-body form excerpt">
                            <div className="card-body">
                                {reportData?.length > 0 && (
                                    <div className="row mb-2">
                                        <div className="col-12">
                                            <div className="d-flex justify-content-center align-items-center">
                                                <input
                                                    className="form-control"
                                                    style={{ width: "500px" }}
                                                    placeholder="Store From, Store To, Part No, Transfer No, or Description"
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="table-responsive">



                                    <table className="table table-bordered table-striped">
                                        <thead
                                            className="sticky-table-header"
                                        >
                                            <tr>
                                                <th>S.No</th>
                                                <th>From-Store</th>
                                                <th>To-Store</th>
                                                <th>Date</th>
                                                <th>Part No</th>
                                                <th>Description</th>
                                                <th>Unit</th>
                                                <th>Auth</th>
                                                <th>Required Transfer Qty</th>
                                                <th>Current Stock</th>
                                                <th>Approved Qty</th>
                                                <th>Recived Qty</th>
                                                <th>Status</th>
                                                <th>Transfer No</th>
                                                <th>MTR</th>
                                                <th>Updated Status</th>
                                                <th>Admin Reason</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredData.length > 0 ? (
                                                filteredData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{(page - 1) * limit + index + 1}</td>
                                                        <td className="scrollable-description">{item?.transfer?.storeFrom?.name}</td>
                                                        <td className="scrollable-description">{item?.transfer?.storeTo?.name}</td>
                                                        <td>{item?.createdAt.split("T")[0]}</td>
                                                        <td>{item?.inventory?.masterItem?.partNo}</td>
                                                        <td className="scrollable-description">{item?.inventory?.masterItem?.description}</td>
                                                        <td>{item?.inventory?.masterItem?.unit?.name}</td>
                                                        <td>{item?.inventory?.qtyAuth}</td>
                                                        <td>{item?.transferQty}</td>
                                                        <td>{item?.inventory?.currentStock}</td>
                                                        <td>{item?.approveQty}</td>
                                                        <td>{item?.recived}</td>
                                                        <td>{item?.status}</td>
                                                        <td>{item?.transfer?.transferNo}</td>
                                                        <td>{item?.mrv?.mrvNo}</td>
                                                        <td>{item?.updatedAt.split("T")[0]}</td>
                                                        <td><div>
                                                            {item?.status === "pending"
                                                                ? "Approval Pending"
                                                                : item?.status === "approved"
                                                                    ? "Pending Received Order"
                                                                    : item?.status === "recived"
                                                                        ? "Completed"
                                                                        : "Unknown Status"}
                                                        </div></td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="17" className="text-center">
                                                        No data available.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>

                                </div>
                                <div className="d-flex justify-content-center align-items-center gap-3 mt-3">

                                    <button
                                        className="btn btn-primary"
                                        disabled={page === 1}
                                        onClick={async () => {
                                            const prevPage = page - 1;
                                            setPage(prevPage);

                                            setLoading(true);
                                            try {
                                                const response = await RequestServies.reportTransferItems({
                                                    fromDate,
                                                    toDate,
                                                    status,
                                                    page: prevPage,
                                                    limit
                                                });

                                                setReportData(response.data);
                                                setTotalCount(response.count);
                                                setTotalPages(response.totalPages); // ✅ NEW

                                            } catch (err) {
                                                console.error(err);
                                            } finally {
                                                setLoading(false);
                                            }
                                        }}
                                    >
                                        Previous
                                    </button>

                                    <span style={{ fontWeight: "bold" }}>
                                        Page {page} of {totalPages} {/* ✅ UPDATED */}
                                    </span>

                                    <button
                                        className="btn btn-primary"
                                        disabled={page >= totalPages}  // ✅ FIXED
                                        onClick={async () => {
                                            const nextPage = page + 1;
                                            setPage(nextPage);

                                            setLoading(true);
                                            try {
                                                const response = await RequestServies.reportTransferItems({
                                                    fromDate,
                                                    toDate,
                                                    status,
                                                    page: nextPage,
                                                    limit
                                                });

                                                setReportData(response.data);
                                                setTotalCount(response.count);
                                                setTotalPages(response.totalPages); // ✅ NEW

                                            } catch (err) {
                                                console.error(err);
                                            } finally {
                                                setLoading(false);
                                            }
                                        }}
                                    >
                                        Next
                                    </button>

                                </div>
                            </div>
                        </div>
                    </Collapse>
                </div>
            </div>
        </>
    );
};

export default TransferReport;
